import React from 'react';
import styled from 'styled-components';
import { motion, useReducedMotion } from 'framer-motion';
import { FaLinkedinIn, FaTwitter, FaInstagram } from 'react-icons/fa';

const List = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.layout.radiusSm};
  flex-wrap: wrap;
`;

const IconButton = styled(motion.a)`
  width: 44px;
  height: 44px;
  border-radius: ${({ theme }) => theme.layout.radiusSm};
  background: rgba(255, 255, 255, 0.1);
  color: ${({ theme }) => theme.colors.textLight};
  display: grid;
  place-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: ${({ $brandColor }) => $brandColor || 'rgba(255, 255, 255, 0.2)'};
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  svg {
    position: relative;
    z-index: 1;
    font-size: 1.1rem;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:hover::before {
    opacity: 1;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 2px;
  }
`;

const SocialIcons = () => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <List aria-label="منصات التواصل الاجتماعي">
      <IconButton
        href="https://www.linkedin.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
        $brandColor="rgba(0, 119, 181, 0.3)"
        whileHover={prefersReducedMotion ? {} : { scale: 1.1, y: -2 }}
        whileTap={prefersReducedMotion ? {} : { scale: 0.95 }}
      >
        <FaLinkedinIn />
      </IconButton>
      <IconButton
        href="https://twitter.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Twitter"
        $brandColor="rgba(29, 161, 242, 0.3)"
        whileHover={prefersReducedMotion ? {} : { scale: 1.1, y: -2 }}
        whileTap={prefersReducedMotion ? {} : { scale: 0.95 }}
      >
        <FaTwitter />
      </IconButton>
      <IconButton
        href="https://www.instagram.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        $brandColor="rgba(225, 48, 108, 0.3)"
        whileHover={prefersReducedMotion ? {} : { scale: 1.1, y: -2 }}
        whileTap={prefersReducedMotion ? {} : { scale: 0.95 }}
      >
        <FaInstagram />
      </IconButton>
    </List>
  );
};

export default SocialIcons;
